export default "__VITE_ASSET__D7pOZAym__"